<template>
  <!-- @mouseenter="handleShowCheckCourse"
       @mouseleave="handleHideCheckCourse" -->
  <div
    class="switch-wrapper"
    :class="['switch-wrapper-' + typeId, isAIRead ? 'ai-reader-switch' : '']"
    @mouseenter="handleShowCheckCourse"
    @mouseleave="handleHideCheckCourse"
  >
    <div class="switch-outter-btn">
      <div class="switch-btn" v-if="showCurrentCourse">
        {{ showCurrentCourse.courseName || showCurrentCourse.name
        }}<i class="iconfont icon-caret-down-small"></i>
      </div>
    </div>
    <div class="switch-box" v-show="isShowSwitchBox && !isAIRead">
      <!--        <div class="switch-box" v-show="true">-->
      <div class="switch-inner-box">
        <div class="courses-box">
          <div class="course-title">
            常用课程
            <div class="edit">
              <div
                class="btn"
                data-io-click="tracker"  @click="$emit('changeAddCourseDialogVisible', true)"
              >
                <span style="font-size: 16px; margin-bottom: 2px">+</span
                >挑选常用课程
              </div>
            </div>
          </div>
          <div class="course-list">
            <div
              class="course-list-item"
              v-if="!course.disabled"
              v-for="(course, index) in newShowUserCourse"
              :key="index"
            >
              <div class="course-list-row">
                <!-- 新增包裹容器 -->
                <div class="stage-name">{{ course.name }}：</div>
                <div class="subject-list">
                  <div
                    class="subject-item"
                    :class="[
                      showCurrentCourse &&
                      subject.courseId == showCurrentCourse.courseId
                        ? 'active'
                        : '',
                    ]"
                    data-io-click="tracker"  @click="handleChooseCourse(subject, index, 1, true)"
                    v-if="subject.isUse"
                    v-for="(subject, index) in course.courseList"
                    :key="index"
                  >
                    {{ subject.subjectName }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <DeleteDialog
      :visible="deleteVisible"
      :showTitle="false"
      :desc="`${this.deleteTip}课程下存在备课资料，删除课程后该课程下的全部备课资料会一起删除，是否确定删除？`"
      @handleClose="handleClose"
      @handleDelete="handleDelete"
    >
    </DeleteDialog> -->
  </div>
</template>
<script>
import util from "@/assets/js/common/util";
import api from "@/assets/js/service/api";
import Bag from "@/components/Bag.vue";
import DeleteDialog from "@/components/DeleteDialog.vue";
import { updateLastUsedCourse } from "@/utils/apis";
import request from "@/utils/request";
import { mapMutations, mapState } from "vuex";
// import Cookie from "js-cookie";
const CURRENTCOURSE = "CURRENTCOURSE";
const WHEREISFROMLAB = "WHEREISFROMLAB";
export default {
  inject: ["textbook"],
  // mixins: [course],
  props: {
    typeId: {
      type: Number,
      default: 1,
    },
    // 是否是实验
    isLab: {
      type: Boolean,
      default: false,
    },
    // 是否是校本
    isTech: {
      type: Boolean,
      default: false,
    },
    // 是否是同步内容产品
    isSyncContent: {
      type: Boolean,
      default: false,
    },
    // 是否是AI阅读
    isAIRead: {
      type: Boolean,
      default: false,
    },
    // 是否是校本
    isSchoolBased: {
      type: Boolean,
      default: false,
    },
    // linshi
    tempCurrentCourse: {
      type: Object,
      default: null,
    },
  },
  components: {
    Bag,
    DeleteDialog,
    // addCourse,
  },
  data() {
    return {
      isShowSwitchBox: false,
      isBagVisible: false,
      chooseCourseList: [],
      // 临时用户课程
      // showUserCourse: [],
      // deleteIds: [],
      deleteVisible: false,
      deleteTip: "",
      disabledCourses: [],
      // 用户权限学段学科
      stageListAndSubjects: [],
      showCurrentCourse: null,
      newShowUserCourse: {},
      newDisabledCourses: [],
      currentSubjectList: [],
      currentStageId: null,
      currentSubjectId: null,
      // currentCourse: null,
    };
  },
  computed: {
    ...mapState({
      // 用户选中的课程包括教材
      userCourses: "userCourses",
      currentCourse: "currentCourse",
      userInfo: "userInfo",
      showUserCourse: "showUserCourse",
      beforeDeleteShowUserCourse: "beforeDeleteShowUserCourse",
      deleteIds: "deleteIds",
      currentReadCourse: "currentReadCourse",
    }),
  },
  watch: {
    userCourses: {
      async handler(newVal, oldVal) {
        let newUserCourses = JSON.parse(JSON.stringify(newVal));
        // console.log("用户课程发生改变", newUserCourses);
        let whereIsFromLab = localStorage.getItem(WHEREISFROMLAB);
        // 禁用的课程
        let disabledCourses = [];
        // 新的当前显示的用户课程
        // let newShowUserCourse = {};
        // 权限内的学段学科
        let stageListAndSubjects = [];
        // 和当前的权限做对比
        // if (!this.isSchoolBased && newUserCourses) {
        //   if (
        //     (!this.isLab || (whereIsFromLab == "tech" && this.isLab)) &&
        //     !this.isAIRead
        //   ) {
        //     let { result } = this.isSyncContent
        //       ? await getSyncCourseList()
        //       : await getStages();
        //     stageListAndSubjects = result;
        //     // AI阅读
        //   } else if (this.isAIRead) {
        //     // console.log("等于Aiyued");
        //     let { result } = await getStageSubjectList();
        //     newUserCourses = stageListAndSubjects = result;
        //     // console.log("stageListAndSubjects", stageListAndSubjects);
        //   } else {
        //     let { result } = await getScsyStageAndSubjectList();
        //     stageListAndSubjects = result;
        //     newUserCourses = newUserCourses.filter(
        //       (item) =>
        //         item.subjectId == 4 ||
        //         item.subjectId == 5 ||
        //         item.subjectId == 6
        //     );
        //   }
        //   if (!this.isAIRead) {
        //     newUserCourses.forEach((course) => {
        //       let stage = stageListAndSubjects.find(
        //         (item) => course.stageId == item.id
        //       );
        //       if (!stage) {
        //         course.disabled = true;
        //         disabledCourses.push(course);
        //       } else {
        //         let subject = stage.subjectList.find(
        //           (subject) => subject.id == course.subjectId
        //         );
        //         if (!subject) {
        //           course.disabled = true;
        //           disabledCourses.push(course);
        //         }
        //       }
        //     });
        //     this.disabledCourses = disabledCourses;
        //   }
        // } else if (this.isSchoolBased && newUserCourses) {
        //   newUserCourses.forEach((item) => {
        //     item.disabled = false;
        //   });
        // }
        // console.log("stageListAndSubjects", newUserCourses);
        // console.log("disabledCourses---", disabledCourses);
        this.setShowUserCourse(JSON.parse(JSON.stringify(newUserCourses)));
        this.setBeforeDeleteShowUserCourse(
          JSON.parse(JSON.stringify(newUserCourses))
        );
      },
      immediate: true,
    },
    isSchoolBased: {
      handler(newVal, oldVal) {
        // console.log("是否是校本", newVal, this.userCourses);
        newVal &&
          this.setShowUserCourse(
            JSON.parse(JSON.stringify(this.userCourses))
          ) &&
          this.setBeforeDeleteShowUserCourse(
            JSON.parse(JSON.stringify(this.userCourses))
          );
      },
    },
    currentCourse: {
      handler(val) {
        if (val) {
          // console.log("currentCourse", val);
          val = this.tempCurrentCourse || val;
          // if (!this.isAIRead) {
          this.showCurrentCourse = JSON.parse(JSON.stringify(val));
          if (this.isAIRead) {
            let { stageId, subjectId } = this.showCurrentCourse;
            this.currentStageId = stageId;
            this.currentSubjectId = subjectId;
          }
        }
      },
      immediate: true,
    },
    // currentReadCourse: {
    //   handler(val) {
    //     // console.log("currentReadCourse", val);
    //     if (val) {
    //       val = this.tempCurrentCourse || val;
    //       if (this.isAIRead) {
    //         // console.log("val", val);
    //         this.showCurrentCourse = JSON.parse(JSON.stringify(val));
    //         let { stageId, subjectId } = this.showCurrentCourse;
    //         this.currentStageId = stageId;
    //         this.currentSubjectId = subjectId;
    //         if (this.showUserCourse) {
    //           let currentStage = this.showUserCourse.find(
    //             (item) => item.id == this.showCurrentCourse.stageId
    //           );
    //           this.currentSubjectList = currentStage
    //             ? currentStage.subjectList
    //             : [];
    //         }
    //         // this.currentSubjectList = this.newShowUserCourse ? this.newShowUserCourse[this.showCurrentCourse.stageId] : []
    //       }
    //     }
    //   },
    //   immediate: true,
    // },
    tempCurrentCourse: {
      handler(val) {
        // console.log("tempCurrentCourse", val);
        // if (!this.isAIRead) {
        this.showCurrentCourse = JSON.parse(JSON.stringify(val));
        // }
      },
      immediate: true,
    },
    isShowSwitchBox: {
      handler(val) {
        if (!val && this.isAIRead && this.showCurrentCourse) {
          // console.log("showCurrentCourse----", this.showCurrentCourse);
          let { stageId, subjectId } = this.showCurrentCourse;
          this.currentStageId = stageId;
          this.currentSubjectId = subjectId;
        }
      },
      immediate: true,
    },
    showUserCourse: {
      async handler(newVal, oldVal) {
        // console.log("newVal-----", newVal, this.showCurrentCourse);
        if (newVal && newVal.length > 0 && newVal[0].courseList) {
          // this.handleCourseList(
          this.newShowUserCourse = this.handleCourseList(newVal);
          // 判断当前显示的学段
          if (this.isAIRead && newVal && this.showCurrentCourse) {
            let currentStage = newVal.find(
              (item) => item.id == this.showCurrentCourse.stageId
            );
            this.currentSubjectList = currentStage
              ? currentStage.courseList
              : [];
          }
        }
      },
      immediate: true,
    },
    disabledCourses: {
      async handler(newVal, oldVal) {
        // console.log('newVal', newVal)
        if (newVal && newVal.length > 0) {
          this.newDisabledCourses = this.handleCourseList(newVal, true);
          // console.log('newDisabledCourses',this.newDisabledCourses,this.handleCourseList(newVal,true))
        }
      },
      immediate: true,
    },
  },
  mounted() {
    // console.log("mounted---", this.currentCourse);
    this.currentCourse &&
      (this.showCurrentCourse = JSON.parse(JSON.stringify(this.currentCourse)));
  },
  methods: {
    ...mapMutations({
      setCurrentCourse: "setCurrentCourse",
      setCourses: "setCourses",
      setShowUserCourse: "setShowUserCourse",
      setBeforeDeleteShowUserCourse: "setBeforeDeleteShowUserCourse",
      setDeleteIds: "setDeleteIds",
      setCurrentReadCourse: "setCurrentReadCourse",
    }),
    async handleSubmit() {
      // console.log("学段学科", this.currentStageId, this.currentSubjectId);
      // let
      if (this.currentStageId && this.currentSubjectId) {
        // console.log("更新课程");
        let { result } = await updateLastUsedCourse({
          stageId: this.currentStageId,
          subjectId: this.currentSubjectId,
          productId: this.textbook.productId,
        });

        if (result) {
          // 更新当前课程
          this.showUserCourse.forEach((stage) => {
            if (stage.id == this.currentStageId) {
              stage.courseList.forEach((subject) => {
                if (subject.subjectId == this.currentSubjectId) {
                  let currentCourse = subject;
                  // currentCourse.stageId = stage.id;
                  // currentCourse.stageName = stage.name;
                  // currentCourse.subjectId = subject.id;
                  // currentCourse.subjectName = subject.name;
                  this.setCurrentCourse(currentCourse);
                  // this.setCurrentCourse(currentCourse)
                  this.isShowSwitchBox = false;
                }
              });
            }
          });
          // this.setShowUserCourse();
        }
      }
    },
    changeCurrentSubjectId(item) {
      this.currentSubjectId = item.subjectId;
    },
    changeCurrentStageId(item) {
      // console.log("item----", item);
      this.currentStageId = item.id;
      this.currentSubjectList = item.courseList;
      // this.currentSubjectId = null;
    },
    handleCourseList(courses) {
      courses.forEach((item) => {
        if (item?.courseList?.length) {
          let findItem = item.courseList.find((course) => course.isUse);
          item.disabled = !findItem;
        }
      });
      return courses;
    },
    // handleCourseList(arr, isDisabled = false) {
    //   // console.log("课程列表----", arr);
    //   let coursesMap = {};
    //   // let judgeStatus = true;
    //   arr.forEach((item) => {
    //     let name = item.courseName || item.name;
    //     let stageName = name.slice(0, 2);
    //     let courseName = name.slice(2);
    //     item.subjectName = courseName;
    //     let status = !isDisabled ? !item.disabled : true;
    //     // console.log('status',status,item)
    //     if (status) {
    //       if (coursesMap[item.stageId]) {
    //         coursesMap[item.stageId].list.push(item);
    //       } else {
    //         coursesMap[item.stageId] = {
    //           stageId: item.stageId,
    //           stageName: stageName,
    //           list: [item],
    //         };
    //       }
    //     }
    //   });
    //   // console.log("coursesMap---", coursesMap);
    //   return coursesMap;
    // },
    handleAddCourse() {
      this.isBagVisible = true;
    },
    handleShowCheckCourse() {
      this.isShowSwitchBox = true;
    },
    handleHideCheckCourse() {
      this.isShowSwitchBox = false;
    },
    handleClose() {},
    handleDelete() {
      this.$message({
        type: "success",
        message: "删除成功!",
      });
      this.setCourses(this.showUserCourse);
      this.setBeforeDeleteShowUserCourse(this.showUserCourse);
      request
        .postJson(api.work.deleteUserCourses, this.deleteIds)
        .then((res) => {
          // 显示提示弹窗
          this.$message({
            type: "success",
            message: "删除成功",
          });
          // 删除完成要判断是否当前的课程被删除掉了如果被删除掉了需要重新设置当前课程
          let findItem = this.deleteIds.find(
            (item) => item === this.currentCourse.courseId
          );
          if (findItem) {
            // 如果被删除掉了重新设置当前学科
            // console.log("userinfo", this.userInfo);
            localStorage.setItem(
              `${this.userInfo.userId}-` + CURRENTCOURSE,
              JSON.stringify(this.showUserCourse[0])
            );
            // 重新设置当前课程
            this.setCurrentCourse(this.showUserCourse[0]);
          }
          this.setDeleteIds([]);
          // this.deleteIds = [];
        })
        .catch((err) => {});
    },
    handleFeedbackDialogVisible(status = true) {
      this.textbook.deleteVisible = status;
      let callback = () => {
        this.textbook.deleteVisible = status;
      };
      this.textbook.noticeParentPageShowMask(
        status,
        callback,
        ".delete-course"
      );
    },
    async handleEdit(deleteIds) {
      let data = await request.postJson(
        api.work.deleteUserCoursesIsTip,
        deleteIds
      );
      if (data.result.isTip) {
        console.log("显示弹窗");
        this.handleFeedbackDialogVisible();
        // this.textbook.deleteVisible = true;
        this.textbook.deleteTip = data.result.courses.join(",");
        // this.textbook.deleteIds = this.deleteIds;
      } else {
        console.log("删除课程", this.showUserCourse, this.deleteIds);
        this.setCourses(this.showUserCourse);
        request
          .postJson(api.work.deleteUserCourses, this.deleteIds)
          .then((res) => {
            // 显示提示弹窗
            this.$message({
              type: "success",
              message: "删除成功",
            });
            // 删除完成要判断是否当前的课程被删除掉了如果被删除掉了需要重新设置当前课程
            let findItem = this.deleteIds.find(
              (item) => item === this.currentCourse.courseId
            );
            if (findItem) {
              // 如果被删除掉了重新设置当前学科
              // console.log("userinfo", this.userInfo);
              localStorage.setItem(
                `${this.userInfo.userId}-` + CURRENTCOURSE,
                JSON.stringify(this.showUserCourse[0])
              );
              // 重新设置当前课程
              this.setCurrentCourse(this.showUserCourse[0]?.courseList[0]);
            }
            this.isShowSwitchBox = false;
            this.setDeleteIds([]);
            // this.deleteIds = [];
          })
          .catch((err) => {});
      }
      // }
    },
    async updateLastUsedCourse(course) {
      let { stageId, subjectId, courseId } = course;
      let data = await updateLastUsedCourse({
        stageId,
        subjectId,
        productId: this.textbook.productId,
      });
      // console.log("----data", data);
    },
    handleChooseCourseById(courseId) {},
    async handleChooseCourse(course, index, type, isCheck = false) {
      console.log("课程参数", course, index, type, isCheck);
      let { stageId, subjectId, courseId } = course;
      if (type == 1) {
        console.log("切换课程");
        isCheck && this.$emit("checkCourse");
        this.setCurrentCourse(course);
        this.updateLastUsedCourse(course);
        // 更新上次使用过的课程
        // window.XEP && window.XEP.message.changeCourse(courseId)
        localStorage.setItem(
          `${this.userInfo.userId}-` + CURRENTCOURSE,
          JSON.stringify(course)
        );
        // }
        this.isShowSwitchBox = false;
        let whereIsFromLab = localStorage.getItem(WHEREISFROMLAB);
        // console.log('whereIsFromLab',whereIsFromLab,'isLab',this.isLab)
        let simpleStage = util.stagesMap[course.stageId];
        let roles = this.userInfo.roles;
        let targetRoles = roles.filter((role) =>
          role.simpleName.startsWith(simpleStage)
        );
        // 判断当前切换的是否是初高中并且判断学段是否只是实操实验权限 如果只有实操实验权限要跳转到实操实验页面
        if (this.isTech) {
          let filterRoles =
            targetRoles.filter(
              (role) =>
                role.simpleName.indexOf("hmkt") > -1 ||
                role.simpleName.indexOf("scsy") > -1
            ) || [];
          // this.isOnlyScsy = !targetRoles.length;
          // console.log("role", filterRoles);
          if (targetRoles.length == filterRoles.length) {
            localStorage.setItem(WHEREISFROMLAB, "tech");
            // 只有实操实验权限
            this.$router.replace("/lab/");
            // }
          }
        } else if (whereIsFromLab == "tech" && this.isLab) {
          let filterRoles = targetRoles.filter(
            (role) => role.simpleName.indexOf("wxt") > -1
          );
          // console.log('targetRoles',targetRoles,filterRoles,filterRoles.length)
          if (filterRoles.length > 0) {
            // console.log('页面跳转')
            this.$router.replace("/tech/");
          }
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.switch-wrapper {
  // float: left;
  display: inline-block;
  position: relative;

  // margin-top: 16px;
  .switch-outter-btn {
    position: relative;
    z-index: 2;

    .switch-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 32px;
      line-height: 32px;
      padding: 0 8px 0 16px;
      color: #4494ff;
      background: #fff;
      font-size: 16px;
      border-radius: 6px;
      transition: all ease-in-out 0.4s;
      font-weight: bold;
      cursor: pointer;

      .iconfont {
        font-size: 20px;
      }

      &:hover {
        .iconfont {
          transform: rotate(180deg);
        }
      }

      i {
        margin-left: 4px;
        font-size: 16px;
        display: inline-block;
        color: #4494ff;
        transition: all ease-in-out 0.4s;
        transform: rotate(0);
      }
    }
  }

  .switch-box {
    position: absolute;
    width: 480px;
    left: 0;
    padding-top: 12px;
    z-index: 2000;

    .switch-inner-box {
      // border-radius: 4px;
      // height: 107px;
      background: #ffffff;
      border: 1px solid #ebeef5;
      box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.06);
      border-radius: 8px;
      position: relative;
      padding: 24px 20px 12px 24px;
      max-height: 500px;
      overflow-y: scroll;
      // display: flex;
      // flex-wrap: wrap;

      //align-items: center;
      &::-webkit-scrollbar {
        //设置滚动条宽高
        display: none;
      }

      // &::after {
      //   position: absolute;
      //   display: block;
      //   content: "";
      //   width: 8px;
      //   height: 8px;
      //   -webkit-transform: rotate(135deg);
      //   -ms-transform: rotate(135deg);
      //   transform: rotate(135deg);
      //   top: -5px;
      //   left: 67px;
      //   border-bottom: 1px solid #ebeef5;
      //   border-left: 1px solid #ebeef5;
      //   box-shadow: 0px 2px 12px 0px rgb(0 0 0 / 6%);
      //   z-index: 1;
      //   background: #fff;
      // }
      .courses-box {
        .course-title {
          color: #1a1a1a;
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 16px;
          line-height: 1;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .course-list {
          // display: flex;
          // flex-wrap: wrap;
          .course-list-item {
            padding-bottom: 20px;

            .course-list-row {
              // 新增行容器
              display: flex;
              //justify-content: space-between;
              align-items: flex-start;
              gap: 8px;
            }

            .stage-name {
              color: #7e7e7e;
              font-size: 14px;
              white-space: nowrap; // 防止文字换行
              margin-top: 2px;
            }

            .subject-list {
              display: flex;
              flex-wrap: wrap;

              .subject-item {
                cursor: pointer;
                margin-bottom: 12px;
                height: 24px;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 0 10px;
                border: 1px solid transparent;
                text-align: center;
                line-height: 24px;
                color: #1a1a1a;
                font-size: 14px;
                margin-right: 12px;
                //background: #e5f7fe;
                border-radius: 4px;
                position: relative;

                .delete-icon {
                  position: absolute;
                  width: 16px;
                  height: 16px;
                  border-radius: 50%;
                  background: #ff6b00;
                  top: -8px;
                  right: -8px;

                  &::after {
                    position: absolute;
                    content: "";
                    display: block;
                    width: 8px;
                    height: 1.5px;
                    left: 50%;
                    background: #fff;
                    top: 50%;
                    transform: translate(-50%, -50%);
                  }

                  &:hover {
                    background: #fbb98e;
                  }
                }

                &:nth-child(4n) {
                  // margin-right: 0px;
                }

                &:hover {
                  color: #0057ff;
                }

                &.disabled-item {
                  background: #eff1f4;
                  color: #80848b;

                  // cursor: not-allowed;
                  &:hover {
                    border: 1px solid transparent;
                  }
                }

                &.active {
                  background: #e5f7fe;
                  color: #0057ff;
                }

                &:nth-of-type(-n + 4) {
                  //margin-top: 0px;
                }

                &.delete-item {
                  //width: 95px;
                  &:hover {
                    // border: none;
                    border: 1px solid transparent;

                    span {
                      color: #fe4509;
                    }
                  }
                }
              }
            }

            &:last-of-type {
              padding-bottom: 0px;
            }
          }

          .add-item {
            cursor: pointer;
            margin-top: 4px;
            width: 100px;
            height: 32px;
            line-height: 32px;
            border: 1px dashed #0057ff;
            position: relative;
            background: #fff;
            color: #0057ff;
            border-radius: 4px;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;

            i {
              font-size: 12px;
              // color: #80848b;
              // font-weight: bold;
              margin-right: 4px;
            }

            // &:hover {
            //   border: 1px dashed #669aff;
            //   color: #0057ff;

            //   i {
            //     color: #0057ff;
            //   }
            // }
          }
        }

        &:nth-of-type(2) {
          padding-top: 20px;
          border-top: 1px solid #e6e7e9;
          margin-top: 20px;

          .course-list {
            border-bottom: none;
            padding-bottom: 0px;
          }
        }
      }

      .edit {
        // width: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        // margin-top: 20px;

        .btn {
          // float: right;
          // width: 48px;
          cursor: pointer;
          // height: 22px;
          // background: #eff1f4;
          // border-radius: 6px;
          // line-height: 22px;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 400;
          color: #4494ff;
          font-size: 13px;

          &:hover {
            // background: #0057ff;
            color: #0057ff;
          }

          &.active {
            // background: #0057ff;
            // color: #fff;
          }
        }
      }

      // margin-top: 8px;
    }

    // top: -61px;
  }

  &.switch-wrapper-2 {
    width: 228px;
    // background: rgba(234, 238, 241, 0.5);
    // border-radius: 8px;
    margin: 0 18px;
    // padding: 6px 0;
    border-bottom: 1px solid #e2e2e2;
    // margin-top: 16px;

    .switch-outter-btn {
      .switch-btn {
        width: 100%;
        text-align: center;
        padding: 0px;
        background: transparent;
        height: 57px;
        line-height: 57px;

        i {
          margin-left: 10px;
        }
      }
    }
  }

  &.switch-wrapper-3 {
    position: absolute;
    width: 100%;

    // display: flex;
    // align-items: center;
    // justify-content: center;
    .switch-btn {
      width: 100%;
      text-align: center;

      .iconfont {
        margin-left: 10px;
      }
    }

    .switch-box {
      left: 75px;

      &.switch-box-type-1 {
        left: -16px;
        padding-top: 0;
        width: 264px;

        .switch-inner-box {
          border-radius: 0px 0px 6px 6px;
          background: #fff;
          box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.02),
            0px 4px 9px 0px rgba(0, 0, 0, 0.03),
            0px 6px 20px 0px rgba(0, 0, 0, 0.05);
          padding: 16px 16px 12px 16px;

          .course-item {
            font-size: 14px;
            display: flex;
            align-items: center;
            margin-bottom: 20px;

            .course-name {
              color: #7e7e7e;
            }

            .item {
              height: 24px;
              line-height: 24px;
              border-radius: 4px;
              background: #e6f2ff;
              padding: 0 10px;
              color: #0057ff;
              margin-right: 16px;
              cursor: pointer;

              &.active {
                background: #0057ff;
                color: #fff;
              }

              &:last-child {
                margin-right: 0;
              }
            }

            // &:last-child{
            //   margin-bottom: 0;
            // }
          }

          .footer {
            display: flex;
            justify-content: flex-end;

            .submit-btn {
              color: #4494ff;
              font-size: 12px;
              cursor: pointer;

              &:hover {
                color: #0057ff;
              }
            }
          }
        }
      }
    }
  }

  &.switch-wrapper-4 {
    // width: 124px;
    // background: rgba(234, 238, 241, 0.5);
    // border-radius: 8px;

    // margin: 0 18px;
    // padding: 6px 0;
    // border-bottom: 1px solid #e2e2e2;
    // margin-top: 16px;

    .switch-outter-btn {
      .switch-btn {
        // padding: 0 16px;
        width: 100%;
        text-align: center;
        // padding: 0px;
        // background: #e6f2ff;
        height: 36px;
        line-height: 36px;
        color: #4494ff;
        // border-radius: 6px;
        font-size: 16px;
        font-weight: bold;
        padding: 0;
        background: transparent;

        i {
          color: #4494ff;
          margin-left: 4px;
          font-weight: 400;
        }
      }
    }

    .switch-box {
      width: 480px;

      .switch-inner-box {
        //background: url("../assets/images/switch-bg.png") no-repeat top center;
        background-color: #fff;
        background-size: 100% 78px;
        padding: 20px;
      }
    }
  }
}

::v-deep .el-tooltip__popper.is-dark {
  background: #ffffff !important;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06) !important;
  border: 1px solid #ebeef5 !important;

  .popper__arrow {
    border-color: #fff !important;
  }
}
</style>
